import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, ImageAvatar, TagsArray, Text, useSettings } from 'app/main/components';
import { DateSquareChip } from 'app/main/components/list-items';
import buttons from './ChronologyButtons';

export default function ChronologyListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.chro_user_assigned_uid}
			avatar={props.model.user_assigned_avatar}
			initials={props.model.chro_title_initials}
			labelBadge={props.model.chty_title_initials}
			labelBadgeTooltip={props.model.chty_title}
			badgeColor={props.model.chty_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 600 ? 8 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.chro_warning_desc && (
								<Tooltip title={props.model.chro_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.chro_blocked_desc && (
								<Tooltip title={props.model.chro_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'chronology', uid: props.model.chro_uid }}
							>
								{props.model.comp_title && `${props.model.comp_title} - `}
								{props.model.chro_title}
							</Text>
						</Grid>
						{/* DATE */}
						<Grid>
							<DateSquareChip value={props.model.chro_date} />
						</Grid>
						{/* TYPE */}
						{/* <Grid>
							{props.model.chty_title && (
								<SquareChip
									label={props.model.chty_title}
									backgroundColor={props.model.chty_color}
								/>
							)}
						</Grid> */}
						{/* TAGS */}
						<Grid>
							<TagsArray tags={props.model.chro_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 600 && (
					<Grid size={4}>
						<Grid container>
							{/* INTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.comp_user_assigned_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_INTUSER')}
								>
									{props.model.user_assigned_title}
								</ButtonLink>
							</Grid>
							{/* EXTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.comp_user_assigned_2_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_EXTUSER')}
								>
									{props.model.user_assigned_2_title}
								</ButtonLink>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
